<template>
  <div class="display-flex align-item-center hidden-extra-content">
    <v-sheet
      v-for="(item, index) in 5"
      :key="index"
      color="grey lighten-4 mr-5"
      class="pa-0"
    >
      <v-skeleton-loader
        width="140px"
        height="100px"
        class="mx-auto"
        type="image"
      ></v-skeleton-loader>
    </v-sheet>
  </div>
</template>

<script>
export default {
  name: "HomePopularCatalogSkeletonLayout",
};
</script>

<style scoped>
.hidden-extra-content {
  width: 100%;
  overflow: hidden;
}
</style>